import React, { useId } from 'react';

export const PRINTED_NAME_HINT = 'Sign the printed form';

interface PrintedNameFieldProps {
  /** Who signs, e.g. "Client/Parent/Guardian" (shown after "Printed name") */
  signer: string;
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  inputClassName: string;
  labelClassName: string;
}

/**
 * Phase 19 F26: the name typed next to a TMHP form's signature line. It is not an electronic
 * signature; the signer signs the printed form, so the field says so.
 */
const PrintedNameField: React.FC<PrintedNameFieldProps> = ({ signer, value, onChange, readOnly = false, inputClassName, labelClassName }) => {
  const id = useId();
  return (
    <>
      <label htmlFor={id} className={labelClassName}>Printed name ({signer})</label>
      <input id={id} type="text" value={value ?? ''} onChange={e => onChange(e.target.value)} readOnly={readOnly}
        className={inputClassName} aria-describedby={`${id}-hint`} />
      <p id={`${id}-hint`} className="text-xs text-gray-500 mt-1 text-left">{PRINTED_NAME_HINT}</p>
    </>
  );
};

export default PrintedNameField;
